module.exports = "//s1.igetcool.com/mall-h5/img/h5_coupon_punch_img_yhq@2x.da16f46e.png";